module.exports = __webpack_public_path__ + "static/media/VPM_mobile_2.f183ed9d.jpg";